export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-950"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20geometric%20shapes%20in%20deep%20crimson%20and%20amber%20tones%2C%20soft%20glowing%20orbs%20floating%2C%20cinematic%20atmosphere%2C%20modern%20streaming%20platform%20aesthetic%2C%20luxurious%20dark%20texture%20with%20subtle%20particles%2C%20no%20text%2C%20abstract%20composition%2C%20professional%20production%20quality&width=1600&height=900&seq=hero-bg-51video&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left: Text */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tag */}
            <div className="inline-flex items-center gap-2 bg-accent-500/20 border border-accent-500/30 rounded-full px-4 py-1.5 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-accent-300 text-sm font-medium">全网热门影视 · 每日更新</span>
            </div>

            {/* H1 */}
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
              51视频
              <span className="block text-accent-400 mt-1">高清免费在线观看平台</span>
            </h1>

            {/* Slogan */}
            <p className="text-lg md:text-xl text-background-200 font-light mb-6">
              不卡顿 · 不缓冲 · 全集免费看
            </p>

            {/* Intro */}
            <p className="text-sm md:text-base text-background-300/90 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              51视频汇聚海量高清影视资源，涵盖51视频在线、91在线视频等热门频道，
              电影、电视剧、综艺、动漫、纪录片一网打尽。采用高速CDN分发技术，
              保障播放流畅不卡顿，让您随时随地畅享高清观影体验。内容每日更新，
              热门大片第一时间上线，追剧不等待。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">10万+</div>
                <div className="text-xs md:text-sm text-background-300">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-400/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">4K</div>
                <div className="text-xs md:text-sm text-background-300">高清画质</div>
              </div>
              <div className="w-px h-10 bg-background-400/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">每日</div>
                <div className="text-xs md:text-sm text-background-300">内容更新</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-full font-semibold text-sm transition-all whitespace-nowrap"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-play-circle-fill text-lg"></i>
                开始观看
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 text-background-50 px-6 py-3 rounded-full font-medium text-sm transition-all whitespace-nowrap"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-fire-line text-lg"></i>
                热门榜单
              </a>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden border border-background-400/20 shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%203D%20abstract%20composition%20with%20floating%20film%20reels%20and%20play%20button%20icons%2C%20warm%20amber%20and%20crimson%20gradient%20lighting%2C%20modern%20streaming%20platform%20visual%2C%20glossy%20glass-like%20surfaces%2C%20depth%20of%20field%2C%20luxurious%20dark%20atmosphere%2C%20no%20text%2C%20professional%20quality&width=800&height=600&seq=hero-visual-51video&orientation=landscape"
                alt="51视频高清在线观看"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-full shadow-lg">
                    <i className="ri-play-fill text-background-50 text-xl"></i>
                  </span>
                  <span className="text-background-50 text-sm font-medium">高清流畅 · 即刻体验</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}